/* tslint:disable:import-spacing no-inferrable-types variable-name align no-trailing-whitespace */

export enum StopEventType {
  CREW_CHANGE  = 0,
  POWER_CHANGE = 1,
  WORK_EVENT   = 2,
  PSG_STOP     = 3,
  OTHER        = 4,
  UNKNOWN      = 5
}

/**
 *
 * @class StopEvent
 *
 * @brief all train stops have to have at least one event; the events make up the activity at that stop.
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      November 2019
 *
 */
export class StopEvent {

  /** @var _tc the train category */
  public       _type: StopEventType = StopEventType.UNKNOWN;

  /** @var _chance the probability of stopping */
  public     _chance: number        = 0.0;

  /** @var _short % probability that the stop is shorter than mean  */
  public      _short: number        = 0.0;

  /** @var _min_hour Minimum Duration of stop (hours) */
  public   _min_hour: number        = 0.0;

  /** @var _mean_hour decimal hours mean stop duration */
  public  _mean_hour: number        = 0.0;

  /** @var _dev_long standard deviation stop time if stop longer than mean  */
  public   _dev_long: number        = 0.0;

  /** @var _dev_short standard deviation stop time if stop shorter than mean  */
  public  _dev_short: number        = 0.0;

  /** @var _nth the zero based index for this item */
  public        _nth: number        = -1;

  /** @brief standard constructor */
  constructor(  t: StopEventType,
                c: number,
                s: number,
               mh: number,
               ah: number,
               dl: number,
               ds: number,
              nth: number) {

    this._type        = t;
    this._chance      = c;
    this._short       = s;
    this._min_hour    = mh;
    this._mean_hour   = ah;
    this._dev_long    = dl;
    this._dev_short   = ds;
    this._nth         = nth;
  }

  /** @brief convert type to a string */
  public static typeToString(dir: StopEventType): string {

    switch (dir) {
      case StopEventType.CREW_CHANGE:  return 'Crew Change';
      case StopEventType.POWER_CHANGE: return 'Power Change';
      case StopEventType.WORK_EVENT:   return 'Work Event';
      case StopEventType.PSG_STOP:     return 'PSG Stop';
      case StopEventType.OTHER:        return 'Other';
      case StopEventType.UNKNOWN:      return 'Unknown';
    }

    return '';
  }

  /** @brief convert string to a type */
  public static typeFromString(dir: string): StopEventType {

    const tmp: string = dir.toLowerCase().trim();

    switch (tmp) {

      case 'c':           return StopEventType.CREW_CHANGE;
      case 'crew change': return StopEventType.CREW_CHANGE;

      case 'p':            return StopEventType.POWER_CHANGE;
      case 'power change': return StopEventType.POWER_CHANGE;

      case 'w':            return StopEventType.WORK_EVENT;
      case 'work event':   return StopEventType.WORK_EVENT;

      case 's':            return StopEventType.PSG_STOP;
      case 'psg':          return StopEventType.PSG_STOP;
      case 'psg stop':     return StopEventType.PSG_STOP;

      case 'o':            return StopEventType.OTHER;
      case 'other':        return StopEventType.OTHER;
    }

    return StopEventType.UNKNOWN;
  }

}
